import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/switchMap";
import { ACTION_MEMBERSTATUSES_LOAD_BY_OUTLOOK_IDS, IMemberStatusesLoadByOutlookIdsAction, IMemberStatusesLoadFailureAction, IMemberStatusesLoadSuccessAction, LoadSuccess, LoadFailure } from "src/actions/memberStatuses";

import { memberStatusesApi } from "../services/memberStatuses";


export const
    getMemberStatusesEpic = (action$): Observable<IMemberStatusesLoadSuccessAction | IMemberStatusesLoadFailureAction> => {
        return action$
            .ofType(ACTION_MEMBERSTATUSES_LOAD_BY_OUTLOOK_IDS)
            .switchMap((action: IMemberStatusesLoadByOutlookIdsAction) => {
                const a = memberStatusesApi
                    .getMemberStatusesByOutlookIds(action.outlookIds);
                const b = a
                    .map(response =>
                        LoadSuccess(response.memberStatuses, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
                return b;
            });
    };
